import type { ReactNode } from "react";
import { PageContainer } from "../layout/PageContainer";
import { PageHeader } from "../layout/PageHeader";
import { NavTiles, type NavTile, type NavTileGroup } from "../ui/NavTiles";

export interface NavigationOverviewProps {
  title?: ReactNode;
  groups?: NavTileGroup[];
  items?: NavTile[];
  empty?: ReactNode;
}

/** Gemeinsamer Seitenaufbau; Kataloge, Rechte und Navigation liefert der Aufrufer. */
export function NavigationOverview({ title, groups, items, empty }: NavigationOverviewProps) {
  const hasItems = groups?.length ? groups.some(group => group.items.length > 0) : !!items?.length;
  return <PageContainer>
    {title != null && <PageHeader title={title} />}
    {!hasItems && empty != null ? empty : <NavTiles groups={groups} items={items} />}
  </PageContainer>;
}
